import { render, staticRenderFns } from "./tmsUseSubCase.vue?vue&type=template&id=bf82ad12&"
import script from "./tmsUseSubCase.vue?vue&type=script&lang=js&"
export * from "./tmsUseSubCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports